import { ApiService } from "../utils/ApiService.js";

export class InventariosService {
  static async listar(incluirAntiguos = false) {
    const endpoint = incluirAntiguos ? "inventarios?incluirAntiguos=true" : "inventarios";
    const data = await ApiService.get(endpoint, null, { cacheTiempo: "1m" });
    return Array.isArray(data) ? data : [];
  }

  static async borrar(id) {
    await ApiService.del("inventario?id=" + encodeURIComponent(id));
    ApiService.invalidate("inventarios");
  }
}
